import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import RegisterForm from './form/form.page'
import FormHelper from '../../../utils/FormHelper'
import Worker from './worker'
import Dialog from '../../../components/dialog/dialog.component'
import Loading from '../../../components/loading/loading.component'
import '../common.styles.scss'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import iconLogo from '../../../assets/images/logo.png'

class AuthRegister extends React.Component {

    constructor(props) {
        super(props)
        this.worker = Worker(this)
        this.state = this.worker.getDefaultState()
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.worker.isValid() && this.worker.register()
    }

    onRememberMeChange = () => this.setState({
        ...this.state,
        rememberMe: !this.state.rememberMe
    })

    render() {
        return (
            <div className="register">
                {this.state.processing && <Dialog><Loading /></Dialog>}
                <header>
                    <img alt="" src={iconLogo} />
                    <h1>Create your account</h1>
                    <p>This secure platform simplifies your membership and makes managing your obligations easy.</p>
                </header>
                <div className={"flag " + this.state.flag.type}>
                    {this.state.flag.text}
                </div>
                <RegisterForm onSubmit={this.onSubmit} onChange={FormHelper(this).onChange} onRememberMeChange={this.onRememberMeChange} {...this.state} />
                <div className="login-action">
                    Already have an account?
                    <Link to="/auth/login">Log In</Link>
                </div>
            </div>
        )
    }
}

export default connect(null)(withRouter(AuthRegister))